<template>
	<div>
		<account-title />

		<a-row type="flex" class="mt-5">
			<a-col :span="24">
				<div class="air__utils__heading d-flex">
					<h5>Top's</h5>

					<a-radio-group
						class="ml-auto"
						v-model="accountType"
						@change="handleTypeChange"
					>
						<a-radio-button :value="1">
							Influencers
						</a-radio-button>
						<a-radio-button :value="2">
							Business
						</a-radio-button>
					</a-radio-group>
				</div>
			</a-col>
			<a-col :span="24" class="mb-3">
				<div class="text-capitalize font-size-15 text-gray-6">
					Top followers
				</div>

				<account-top-followers :accountType="accountType" />
			</a-col>

			<a-col :span="24">
				<div class="text-capitalize font-size-15 text-gray-6">
					Top engagement
				</div>

				<account-top-engagment :accountType="accountType" />
			</a-col>
		</a-row>

		<a-row type="flex" justify="center">
			<a-col :span="24">
				<div class="air__utils__heading d-flex align-items-center">
					<h5>Availables</h5>
				</div>
			</a-col>
		</a-row>

		<a-row>
			<a-col :span="24" type="flex" justify="end">
				<account-table-list :accountType="accountType" />
			</a-col>
		</a-row>
	</div>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import * as MUTATIONS from '@/store/mutations'
import { mapGetters, mapActions, mapMutations } from 'vuex'

import AccountTitle from '@/components/widgets/Account/Title'

import AccountTableList from '@/components/widgets/Account/List'
import AccountTopFollowers from '@/components/widgets/Account/TopFollowers'
import AccountTopEngagment from '@/components/widgets/Account/TopEngagement'

export default {
	name: 'Account',
	components: {
		AccountTitle,
		AccountTopFollowers,
		AccountTopEngagment,
		AccountTableList,
	},
	data() {
		return {
			groups: [],
			showFilter: false,
			accountType: 1,
		}
	},
	created() {
		this.loadAccountGroup()
		this.loadAccountTypes()
	},
	methods: {
		handleFilter() {
			this.showFilter = !this.showFilter
		},
		handleTypeChange(e) {
			this.changeType(e.target.value)
		},
		...mapActions({
			loadAccountGroup: ACTIONS.ACCOUNT_GROUP.LIST,
			loadAccountTypes: ACTIONS.ACCOUNT_TYPE.LIST,
		}),
		...mapMutations({
			changeType: MUTATIONS.ACCOUNT.CHANGE_TYPE,
		}),
	},
	computed: {
		...mapGetters(['getCurrentUser']),
	},
}
</script>

<style lang="scss">
@import './list.style.module.scss';
</style>
